import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const baseOptions: ToastOptions = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: true,
};

class ToastUtil {
    info = (message: string) => toast.info(message, baseOptions);

    success = (message: string) => toast.success(message, baseOptions);

    error = (message: string) => toast.error(message, baseOptions);
}

const toastUtilInstance = new ToastUtil();
export default toastUtilInstance;
